import { render, staticRenderFns } from "./statisticalAnalysis.vue?vue&type=template&id=853f27ac&scoped=true&"
import script from "./statisticalAnalysis.vue?vue&type=script&lang=js&"
export * from "./statisticalAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./statisticalAnalysis.vue?vue&type=style&index=0&id=853f27ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853f27ac",
  null
  
)

export default component.exports